import React, { FC, memo } from 'react';
import StreamdownRenderer from './streamdown';
import ReactMarkdownRenderer from './react-markdown';
import { isImageProxyEnabled, withImageProxy } from '@/common/imageProxy';

// 渲染器选择配置 - 修改这个变量来切换渲染器
// 设置为 'streamdown' 或 'react-markdown'
// react-markdown 的样式未维护，暂时使用 streamdown
const MARKDOWN_RENDERER = 'react-markdown';
interface MarkdownPropsType {
    content: string;
    className?: string;
}

export type MarkdownCompPropsType = MarkdownPropsType;


function replaceStr(str) {
    if (!str) return str;

    let result = str;

    // 仅在开启图片代理时，对 markdown 图片与 <img> 进行 URL 替换，其他文本完全不动
    if (isImageProxyEnabled) {
        // markdown 图片：![alt](http...)
        result = result.replace(
            /(!\[[^\]]*]\()\s*(https?:\/\/[^)\s]+)(\s*\))/gi,
            (match, p1, url, p3) => `${p1}${withImageProxy(url)}${p3}`
        );

        // HTML 图片：<img src="http...">
        result = result.replace(
            /(<img[^>]*src=["'])(https?:\/\/[^"'>\s]+)(["'])/gi,
            (match, before, url, after) => `${before}${withImageProxy(url)}${after}`
        );
    }

    return result;
}


const MarkdownIndex: FC<MarkdownPropsType> = memo((props) => {
    const { content } = props;
    const resultContent = replaceStr(content);

    if (String(MARKDOWN_RENDERER) === 'react-markdown') {
        return <ReactMarkdownRenderer
            {...props}
            content={resultContent}
        />;
    }

    return <StreamdownRenderer
        {...props}
        content={resultContent}
    />;
});

export default MarkdownIndex;
